import { __decorate } from "tslib";
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let Ui = class Ui extends VuexModule {
    constructor() {
        super(...arguments);
        this.isSideBarOpen = null;
        this.isDarkSide = false;
    }
    async updateSideBar(value) {
        return {
            isSideBarOpen: value
        };
    }
    async toggleDarkSide(value) {
        return {
            isDarkSide: value
        };
    }
};
__decorate([
    MutationAction({ mutate: ['isSideBarOpen'] })
], Ui.prototype, "updateSideBar", null);
__decorate([
    MutationAction({ mutate: ['isDarkSide'] })
], Ui.prototype, "toggleDarkSide", null);
Ui = __decorate([
    Module({ namespaced: true, name: 'ui' })
], Ui);
export default Ui;
